const ALL_DOMAINS = -1;
import Cookies from 'js-cookie';
import request from '@/utils/request';
function transformItem2Dto(item) {
  const dto = {
    domainID: item.id,
    ...item
  };
  delete dto.id;
  delete dto.products;
  const products =
    item.products &&
    item.products.map(product => {
      const productDto = {
        productID: product.productID,
        code: product.code,
        description: product.description,
        priceListItemID: product.priceListItemID
      };
      return productDto;
    });
  dto.products = products || [];
  return dto;
}

function transformDto2Item(dto) {
  const item = {
    ...dto,
    id: dto.domainID
  };
  delete item.domainID;
  if (item.rfidPrefix === null) {
    item.rfidPrefix = undefined;
  }
  return item;
}

export const apiOverrides = { transformItem2Dto, transformDto2Item };

function getCulturesForDomain(domainID) {
  return request({
    method: 'get',
    url: 'culture/getCulturesForDomain',
    params: {
      domainID: domainID
    }
  });
}
export const storeExtensions = {
  actions: {
    setCurrentDomainID({ commit }, domainID) {
      commit('SET_CURRENT_DOMAIN', domainID);
    },
    clearCurrentDomainID({ commit }) {
      commit('SET_CURRENT_DOMAIN', 0);
    },
    selectAllDomains({ commit }) {
      commit('SET_CURRENT_DOMAIN', ALL_DOMAINS);
    },
    getCulturesForDomain({ dispatch }, domainID) {
      return new Promise((resolve, reject) =>
        getCulturesForDomain(domainID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  },
  getters: {
    getCurrentDomainID(state) {
      return state.currentDomainID && +state.currentDomainID;
    },
    getDefaultSelectValueDomainID(state, getters) {
      const id = state.currentDomainID && +state.currentDomainID;
      return id === ALL_DOMAINS ? null : id;
    },
    ALL_DOMAINS() {
      return ALL_DOMAINS;
    }
  },
  mutations: {
    SET_CURRENT_DOMAIN: (state, currentDomainID) => {
      state.currentDomainID = currentDomainID;
      if (currentDomainID >= 0 || currentDomainID === ALL_DOMAINS) {
        Cookies.set('currentDomainID', currentDomainID);
      } else {
        Cookies.remove('currentDomainID');
      }
    }
  },
  state: {
    ALL_DOMAINS,
    currentDomainID: +Cookies.get('currentDomainID') || ''
  }
};
